import React, { memo, useRef } from "react";
import { PhotoLibraryIcons } from "../../../../utils/B2B/PhotoLibraryContent";
import { DefaultVendorPhotoLibrarySectionNamesEnum } from "../../../../constants/enums";
import { IPhotoLibrarySection } from "../../../../interfaces/photoLibrary";
import "./PhotoLibraryUploadZone.scss";

interface PhotoLibraryUploadZoneProps {
	className?: string;
	isDragging: boolean;
	activeSection: IPhotoLibrarySection | null;
	onFileSelect: (files: FileList | null) => void;
	onDragOver: (e: React.DragEvent) => void;
	onDragLeave: (e: React.DragEvent) => void;
	onDrop: (e: React.DragEvent) => void;
}

const PhotoLibraryUploadZone: React.FC<PhotoLibraryUploadZoneProps> = ({
	className,
	isDragging,
	activeSection,
	onFileSelect,
	onDragOver,
	onDragLeave,
	onDrop,
}) => {
	const fileInputRef = useRef<HTMLInputElement>(null);
	const vendorProfileSectionName = DefaultVendorPhotoLibrarySectionNamesEnum.VendorProfileImages;
	const isDisabled = activeSection?.sectionName === vendorProfileSectionName;

	return (
		<>
			<input
				ref={fileInputRef}
				type="file"
				accept="image/png,image/jpeg"
				multiple
				onChange={(e) => onFileSelect(e.target.files)}
				style={{ display: "none" }}
			/>
			<div
				className={`upload-dropzone ${className ?? ""} ${isDragging ? "dragging" : ""} ${isDisabled ? "disabled" : ""}`}
				onClick={() => {
					!isDisabled && fileInputRef.current?.click();

					if (fileInputRef.current) {
						fileInputRef.current.value = "";
					}
				}}
				onDragOver={!isDisabled ? onDragOver : undefined}
				onDragLeave={!isDisabled ? onDragLeave : undefined}
				onDrop={!isDisabled ? onDrop : undefined}
			>
				<div className="dropzone-icon-large">
					<PhotoLibraryIcons.Upload />
				</div>
				<div className="dropzone-text-primary">
					{isDisabled
						? "Upload disabled for this section"
						: isDragging
							? "Drop images here"
							: "Drag & drop photos here"}
				</div>
				{!isDisabled && (
					<>
						<div className="dropzone-text-secondary">
							or <span className="dropzone-browse-link">browse files</span>
						</div>
						<div className="dropzone-text-hint">PNG, JPEG or JPG up to 10MB</div>
						<div className="dropzone-text-library">
							Photos uploaded will be saved to your library for future use
						</div>
					</>
				)}
			</div>
		</>
	);
};

export default memo(PhotoLibraryUploadZone);

